import React from "react"
import {Button} from "react-bootstrap"
import {useTranslation} from "react-i18next"

interface DeleteButtonProps {
  id: string
  onClick: () => void
  title: string | undefined
  disabled: boolean | undefined
}

function DeleteButton({id, onClick, title, disabled}: DeleteButtonProps) {
  const {t} = useTranslation('Components.Buttons')

  return (
    <Button
      id={`delete-${id}`}
      onClick={onClick}
      variant={'danger'}
      disabled={disabled}
    >
      {title ? t('delete', {item: title}) : t('deleteSimple')}
    </Button>
  )
}

export default DeleteButton
